import {
  isSpaceCalendarView,
  shouldShowSpaceContent,
} from "@/react/helpers/spaceHelpers";
import type { Space } from "@/react/types";
import { NewListView } from "@circle-react/components/Events/NewEventsSpace/ListView";
import { SpaceCalendarView } from "@circle-react/components/Events/NewEventsSpace/SpaceCalendarView";
import { useSpaceParams } from "@circle-react/components/Events/hooks/useSpaceParams";
import { SpaceLockScreen } from "@circle-react/components/Spaces/Show/SpaceLockScreen";
import { usePunditUserContext } from "@circle-react/contexts";
import { Banner } from "../WelcomeBanner/Banner";

interface ContentProps {
  isLockedSpace: boolean;
  refetchSpace?: () => void;
  space: Space;
}

export const Content = ({
  space,
  isLockedSpace,
  refetchSpace,
}: ContentProps) => {
  const { sort, pastEvents, status } = useSpaceParams();
  const { currentCommunitySettings } = usePunditUserContext();
  const {
    space_description_enabled: isSpaceDescriptionEnabled,
    event_space_calendar_view_enabled: isSpaceCalendarViewEnabled,
  } = currentCommunitySettings || {};

  if (!shouldShowSpaceContent(space)) {
    return null;
  }

  if (isLockedSpace) {
    return <SpaceLockScreen space={space} />;
  }

  const shouldDisplayCalendarView =
    isSpaceCalendarViewEnabled && isSpaceCalendarView(space);

  if (shouldDisplayCalendarView) {
    return <SpaceCalendarView />;
  }
  return (
    <>
      {isSpaceDescriptionEnabled && (
        <Banner space={space} refetchSpace={refetchSpace} />
      )}
      <NewListView sort={sort} pastEvents={!!pastEvents} status={status} />
    </>
  );
};
